module.exports = {
          srcSet: __webpack_public_path__ + "601e52a453c35e406f6731cb009de05e-19.png"+" 19w",
          images:[ {path: __webpack_public_path__ + "601e52a453c35e406f6731cb009de05e-19.png",width: 19,height: 19}],
          src: __webpack_public_path__ + "601e52a453c35e406f6731cb009de05e-19.png",
          toString:function(){return __webpack_public_path__ + "601e52a453c35e406f6731cb009de05e-19.png"},
          
          width: 19,
          height: 19
        }